import React, { useState, useEffect, useRef } from "react";
import Scrollbar from "./Scrollbar";

export default function ResourceTopicFilter({ topics, setTopics, isMobile }) {
  const [allActive, setAllActive] = useState(topics.every((topic) => topic.active));
  const [accordionOpen, setAccordionOpen] = useState(false);

  const topicListRef = useRef(null);

  const handleCheckboxChange = (event, topic) => {
    const filterIndex = topics.findIndex((t) => t.id === event.target.value);
    const topicToUpdate = topics[filterIndex];

    if (allActive) {
      setTopics(
        topics.map((topic) => ({ ...topic, active: topic.id == topicToUpdate.id ? true : false }))
      );
    } else {
      // if no topic are selected at all, set all to active
      if (topics.filter((topic) => topic.active).length <= 1 && topicToUpdate.active) {
        setAllActive(true);
        setTopics(topics.map((topic) => ({ ...topic, active: true })));
      } else {
        topicToUpdate.active = !topicToUpdate.active;
        setTopics([
          ...topics.slice(0, filterIndex),
          topicToUpdate,
          ...topics.slice(filterIndex + 1),
        ]);
      }
    }
    setAllActive(topics.every((topic) => topic.active));
  };

  const handlAllCheckboxChange = (event) => {
    if (event.target.checked) {
      setTopics(topics.map((topic) => ({ ...topic, active: true })));
    }
    setAllActive(true);
  };

  useEffect(() => {
    setAllActive(topics.every((topic) => topic.active));
  }, [topics]);

  const Filter = (
    <form className="resource-topic-filter">
      <ul className="checkbox-list" ref={topicListRef}>
        <li>
          <input
            checked={allActive}
            id="all-topics"
            type="checkbox"
            disabled={allActive}
            onClick={handlAllCheckboxChange}
            value={0}
          />
          <label className="bold font-size-s" htmlFor="all-topics">
            All
          </label>
        </li>
        {topics.map((topic, index) => (
          <li key={topic.id}>
            <input
              checked={!allActive && topics[index].active}
              id={`topic-${topic.id}`}
              type="checkbox"
              value={topic.id}
              onChange={(event) => handleCheckboxChange(event, topic)}
            />
            <label className="bold font-size-s" htmlFor={`topic-${topic.id}`}>
              {topic.name}
            </label>
          </li>
        ))}
      </ul>
      <Scrollbar parentRef={topicListRef} />
    </form>
  );

  if (topics.length === 0) return;

  if (!isMobile) {
    return (
      <div className={`topics-accordion accordion ${accordionOpen ? "accordion--open" : ""}`}>
        <div className="accordion-header">
          <button
            className="accordion-toggle button button--caret"
            aria-controls={`topics-content`}
            aria-expanded={accordionOpen}
            onClick={() => setAccordionOpen(!accordionOpen)}
          >
            See Results by Topic
          </button>
        </div>
        <div id="topics-content" className="accordion-body" hidden={!accordionOpen}>
          <div className="accordion-body-content">{Filter}</div>
        </div>
      </div>
    );
  } else {
    return Filter;
  }
}
